(() => {
  const root = document.querySelector('[data-ps-product]');
  if (!root) return;
  const input = root.querySelector('[data-ps-variant-input]');
  const options = root.querySelectorAll('[data-ps-variant-option]');
  const priceTargets = root.querySelectorAll('[data-ps-price], [data-ps-button-price], [data-ps-sticky-price]');
  if (input && options.length) {
    options.forEach((option) => {
      option.addEventListener('click', () => {
        if (option.disabled) return;
        input.value = option.dataset.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        options.forEach((item) => {
          const active = item === option;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        priceTargets.forEach((target) => { target.textContent = option.dataset.price; });
      });
    });
  }
  const sticky = root.querySelector('[data-ps-pdp-sticky]');
  const form = root.querySelector('.ps-pdp__form');
  if (sticky && form) {
    const trigger = root.querySelector('.ps-pdp__add') || form;
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', entry.intersectionRatio < 0.9), { threshold: [0, 0.9] });
    observer.observe(trigger);
    sticky.querySelector('[data-ps-scroll-buy]')?.addEventListener('click', () => form.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }
})();
